// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3304":"020ade207f675b99","6287":"8102405bf51ac542"}[chunkId] + ".js";
};